import React,{ useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome,faArrowLeft } from '@fortawesome/free-solid-svg-icons'



function RegisterForm() {

 const navigate = useNavigate();




  const initialValues = { email: "", name: "", lastName: "", company:"", phone: "" };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);





  const handleChange = (e) => {
    
    const { name, value } = e.target;
    if(name !== 'phone'){
        setFormValues({ ...formValues, [name]: value });
    }

    else{
        const masked = value.replaceAll('-','').replace(/\D/g,'').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        const result = !masked[2]
        ? masked[1]
        : `${masked[1]}-${masked[2]}-${masked[3]}`;
        setFormValues({...formValues, [name]: result})

    }
  


  };

  const handleSubmit = (e) => {
  

    e.preventDefault();
    setFormErrors(validate(formValues));
    setIsSubmit(true);

   
  };

  const backHome = (e) => {
    e.preventDefault();
    // console.log("TOUCHED");
    navigate('/evaluacion/home',{replace: true})
  };



  useEffect(() => {

    if (Object.keys(formErrors).length === 0 && isSubmit) {

    navigate('/evaluacion/exam', {state:formValues})
    

      
     
    }
  }, [formErrors]);

 

  const validate = (values) => {
   
    const errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    const phoneRegex = /\D/g
    if (!values.name) {
        errors.name = "El nombre es requerido";
      }
    if (!values.lastName) {
        errors.lastName = "El apellido es requerido";
      }
    if (!values.company) {
        errors.company = "La empresa es requerida";
      }
    if (!values.phone) {
        errors.phone = "El teléfono es requerido";
      }else if(!phoneRegex.test(values.phone)){
        errors.phone = "Ingrese un número telefónico válido";
      }
      else if(values.phone.replaceAll('-','').length < 10){
        errors.phone = "Complete el número telefónico";
      }
    if (!values.email) {
      errors.email = "El correo es requerido";
    } else if (!regex.test(values.email)) {
      errors.email = "Este no es un correo válido";
    }
    return errors;
  };



  

  return (
    <div  className="grid col-start-1 ">
        <div className="bg-black rounded-xl m-4 p-4 justify-left w-min flex cursor-pointer hover:bg-gray-700 " onClick={backHome}><FontAwesomeIcon icon={faHome} /> 
        <FontAwesomeIcon icon={faArrowLeft} className="ml-2 "/>
        </div>

    
    <div className="flex justify-center self-center">
    

{/* <h1 className="text-white font-bold text-3xl mt-10">Rifa SPN en CIGEH-ADOARH 2022</h1> */}

        {/* <h1 className="text-3xl font-bold">Formulario de Registro</h1> */}

        <div className="mt-10"></div>

        <form className="w-full max-w-lg bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4" onSubmit={handleSubmit}>
      
      <div class="flex flex-wrap -mx-3 mb-6">
  <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-first-name">
      Nombre
    </label>
    <input class="appearance-none block w-full bg-gray-200 text-gray-700 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-first-name"
      type="text"
      name="name"
      placeholder="Nombre"
      value={formValues.name}
      onChange={handleChange}></input>
     <p className="text-red-500">{formErrors.name}</p>
  </div>
  <div class="w-full md:w-1/2 px-3">
    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-last-name">
      Apellido
    </label>
    <input class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-last-name" 
          type="text"
          name="lastName"
          placeholder="Apellido"
          value={formValues.lastName}
          onChange={handleChange}
    ></input>
     <p className="text-red-500 pt-3">{formErrors.lastName}</p>
  </div>
</div>
<div class="flex flex-wrap -mx-3 mb-6">
  <div class="w-full px-3">
    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-password">
      Correo Electrónico
    </label>
    <input class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-password" type="email" placeholder="example@example.com"
          name="email"
          value={formValues.email}
          onChange={handleChange}
    ></input>
    {/* <p class="text-gray-600 text-xs italic mb-3">El certificado será enviado a este correo</p> */}
    <p className="text-red-500 pb-10">{formErrors.email}</p>
  </div>
  <div class="w-full px-3">
    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-password">
      Empresa
    </label>
    <input class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-password" type="text" placeholder="Empresa"
          name="company"
          value={formValues.company}
          onChange={handleChange}
          ></input>
           <p className="text-red-500 pb-10">{formErrors.company}</p>
  
  </div>
  <div class="w-full px-3">
    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-password">
      Teléfono
    </label>
    <input class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-password" type="text"
          name="phone"
          placeholder="(809)-555-5555"
          value={formValues.phone}
          onChange={handleChange}
          ></input>
          <p className="text-red-500">{formErrors.phone}</p>
   
  </div>
</div>

<button class="inline-flex self-center justify-center text-center bg-[#4A0094] hover:[#643A90] text-white font-bold py-2 px-4 rounded-full focus:outline-none focus:shadow-outline w-64" >
      Iniciar Examen
    </button>

    </form>
    </div>
    </div>
  );
}

export default RegisterForm;